import { Close } from '@mui/icons-material';
import { Button, IconButton, Modal, TextField } from '@mui/material';
import { Row } from 'antd';
import Loading from 'components/Loading';
import SelectableBookByGroup from 'components/SelectBookByGroup';
import { get } from 'lodash';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { handleUpdateClasslinkCources } from 'store/booksUnits/thunks';
import styled from 'styled-components';
import COLOR from 'utils/constants/color';

const ModalContent = styled.div`
    align-items: center;
    background-color: ${COLOR.white};
    border-radius: 3px;
    display: inline-flex;
    flex-direction: column;
    left: 50%;
    width:90vw;
    height:90vh;
    padding: 16px;
    position: absolute;
    text-align: center;
    top: 50%;
    transform: translate(-50%, -50%);
`;
const ModalSection =  styled.div`
    background-color: ${COLOR.white};
    display: inline-flex;
    flex-direction: column;
    width:90vw;
    height:100%;
    overflow:auto;
    padding: 16px;
`;

export const ClasslinkCourseModal = ({ openEditModal, setOpenEditModal, selectedData , onUpdate}) => {
    const [courseName, setCourseName] = useState(get(selectedData, 'displayName', ''))
    const [courseBooksByGroup, setCourseBooksByGroup] = useState([])
    const [loader, setLoader] = useState(null)

    useEffect(() => {
        if (selectedData) {
            setCourseName(get(selectedData, 'displayName', ''))
            const books_group = get(selectedData, 'books_group', []) || []
            setCourseBooksByGroup(books_group)
        }
    }, [selectedData])
    const dispatch = useDispatch()

    const onCourseUpdate = async () => {
        const data = {
            ...selectedData,
            id: selectedData.id,
            displayName: courseName,
            books_group: courseBooksByGroup
        }
        setLoader(true)
        await dispatch(handleUpdateClasslinkCources(data))
        if(onUpdate){
            onUpdate()
        }
        setLoader(false)
        setOpenEditModal(false)
    }
    return (
        <Modal open={openEditModal} onClose={() => setOpenEditModal(false)}>
            <ModalContent>
                <Row style={{ justifyContent: "flex-end", width: "100%" }}>
                    <IconButton
                        onClick={e => setOpenEditModal(false)}
                        style={{ padding: 0, marginRight: 10 }}
                    >
                        <Close color="secondary" />
                    </IconButton>
                </Row>
                <h2>{"Update Course"}</h2>
                <Row style={{ width: "100%" }}>
                    <TextField value={courseName} disabled onChange={(e) => setCourseName(e.target.value)} label="District" variant="outlined" style={{ maxWidth: 400 }} />
                </Row>
                <ModalSection>
                   <SelectableBookByGroup
                        books_group={courseBooksByGroup}
                        onSelect={(item) => {
                            setCourseBooksByGroup(item)
                        }} />
                </ModalSection>
                <Row style={{ width: "100%", marginTop: 20 , justifyContent:"flex-end"}}>
                    <Button variant="contained" color="primary" onClick={onCourseUpdate}>{loader?<Loading size={14} white/>:null} {selectedData && selectedData.id ? "Update" : "Create"}</Button>
                </Row>
            </ModalContent>
        </Modal>
    )
}


